import axios from 'axios'
// import Vue from 'vue'
import {
    Message
} from 'element-ui'
// import store from '@/utils/store'
import {
    removeToken
} from '@/utils/auth'
import router from '@/router/index'




// create an axios instance
const service = axios.create({
    baseURL: "", // api 的 base_url
    withCredentials: true,
    timeout: 30 * 1000 // 默认最长时间30秒
})

//axios.defaults.withCredentials = true;

// 拦截器
service.interceptors.request.use(
    (    config: any) => {
        // Do something before request is sent
        // if (store.getters.token) {
        //     // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
        //     config.headers['X-Token'] = getToken()
        // }
        return config
    },
    (    error: any) => {
        // Do something with request error
        console.log(error) // for debug
        Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    (   
    response: { data: { code: number; success: boolean; message: string; data: any} }) => {
        // console.log("data",response);

        // 请求成功返回
        if (response.data.success) {
            return Promise.resolve(response.data.data);
        } 

        // 请求响应失败逻辑
        else {
            // 登录状态过期
            if(response.data.code == 19000){
                Message({
                    message: "登陆状态已过期，需要重新登陆！",
                    type: 'error',
                    duration: 3 * 1000
                })

                // 清理 cookie
                removeToken();
                router.push("/pages/login");
                return Promise.reject(response.data.message);
            }

            // 通用返回错误处理
            else {
                Message({
                    message: response.data.message,
                    type: 'error',
                    duration: 3 * 1000
                })
    
                return Promise.reject(response.data.message);
            }
        }
    },
    ( error: any) => {
        console.log(error)
        if (axios.isCancel(error)) {
            console.log("已经取消");
        } else {
            Message({
                message: error,
                type: 'error',
                duration: 3 * 1000
            })

            return Promise.reject(error)
        }
    }
)

export default service